import React from 'react'
import { Link } from "react-router-dom";


const HomeAbout = () => {
    return (
        <>

            <section className="section-about" style={{ overflow: "hidden", marginTop: "-130px" }}>
                <div className="position-relative section-space">
                    <div className="container">
                        <div className="row justify-content-between align-items-center gy-5 flex-column-reverse flex-lg-row">
                            <div className="col-lg-5 col-xxl-6">
                                <div className="about-left-block">
                                    <div className="image-block animate-bottom-to-top">
                                        <img src="assets/img/about_1.webp" alt="about-img-1" width={439} height={538} className="img-fluid animate-bottom-to-top" data-animation-duration={1} data-animation-delay="0.5" />
                                    </div>
                                    {/* <div className="image-block">
                                        <img src="assets/images/about-img-1.jpg" alt="about-img-1" width={375} height={359} className="img-fluid animate-left-to-right" data-animation-duration={1} data-animation-delay={1} />
                                    </div> */}
                                    <img src="assets/images/abstract/dot-1.svg" alt="dot-1" width={198} height={93} className="img-fluid animate-top-to-bottom" data-animation-duration={1} />
                                    {/* <div className="about-shape-block animate-zoom-in" data-animation-duration={1} data-animation-delay="0.5">
                                        <div className="about-shape-inner-block">
                                            <img src="assets/images/abstract/star-curve-shape-blue.svg" alt="star-curve-shape-blue" width={200} height={200} className="img-fluid" />
                                            <div className="about-shape-text">
                                                <span>24+</span>
                                                Our Experience
                                            </div>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                            <div className="col-lg-7 col-xxl-5">
                                <div className="about-right-block">
                                    <div className="about-content">
                                        <div className="section-content-block">
                                            <span className="section-tag">Welcome to Rahul Logistics Katni</span>
                                            <h2 className="section-title is-text-dark">Providing <strong> Logistics </strong>
                                                Services &amp; Transport Services for You</h2>
                                            <p className="section-text">We are primarily a transporter organization that provides logistics services for all types of trucks. The company began in 2000 with a single truck under the name Rahul Logistics and has grown exponentially over the past few decades. The company operates from Jabalpur Road, Katni. We are committed to providing the best service to ensure your success.</p>
                                        </div>
                                        <hr />
                                        <div>
                                            <div className="row mb-4">
                                                <ul className="col-auto content-list content-list-1">
                                                    <li>Real-Time Tracking</li>
                                                    <li>On-Time Delivery </li>
                                                </ul>
                                                <ul className="col-auto content-list content-list-1">
                                                    <li>Customizable Logistics Solutions</li>
                                                    <li>24/7 Customer Support</li>
                                                </ul>
                                            </div>

                                            <div className="d-flex align-items-center flex-wrap gap-4 gap-lg-5 mt-5">
                                                <Link to="/about" className="btn btn-secondary">
                                                    Explore More
                                                    <div className="btn-icon">
                                                        <span>
                                                            <i className="fa-regular fa-arrow-right" />
                                                        </span>
                                                        <span>
                                                            <i className="fa-regular fa-arrow-right" />
                                                        </span>
                                                    </div>
                                                </Link>
                                                <div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Section Images */}
                    <div className="about-section-img">
                        <img src="assets/images/about-section-img-1.png" alt="about-section-img" width={278} height={168} className="animate-left-to-right" data-animation-duration="1.5" />
                        <img src="assets/images/about-section-abstract-img-1.svg" alt="about-section-abstract-img-1" width={211} height={375} className="animate-zoom-in" data-animation-duration="1.5" />
                        <img src="assets/images/about-section-abstract-img-2.svg" alt="about-section-abstract-img-2" width={332} height={480} className="animate-zoom-in" data-animation-duration="1.5" />
                        <img src="assets/images/about-section-abstract-img-3.svg" alt="about-section-abstract-img-3" width={226} height={115} className="animate-zoom-in" data-animation-duration="1.5" />
                    </div>
                    {/* Section Images */}
                </div>
            </section>

            <section className="counter-section fix section-space bg-cover" style={{ backgroundImage: 'url("assets/images/home-3/counter/counter-bg.jpg")', marginTop: "-50px" }}>
                <div className="container">
                    <div className="counter-wrapper">
                        <div className="counter-items wow fadeInUp" data-wow-delay=".2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp', textAlign: "center" }}>
                            <div className="fun-fact-value" data-module="countup">
                                <span className="start-number" data-countup-number={24}>24</span>+
                            </div>
                            <h5>Years Experience</h5>
                        </div>
                        <div className="counter-items wow fadeInUp" data-wow-delay=".4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp', textAlign: "center" }}>
                            <div className="fun-fact-value" data-module="countup">
                                <span className="start-number" data-countup-number={34}>34</span>+
                            </div>

                            <h5>Bookings Completed</h5>
                        </div>
                        <div className="counter-items wow fadeInUp" data-wow-delay=".6s" style={{ visibility: 'visible', animationDelay: '0.6s', animationName: 'fadeInUp', textAlign: "center" }}>
                            <div className="fun-fact-value" data-module="countup">
                                <span className="start-number" data-countup-number={96}>96</span>%
                            </div>

                            <h5>Happy Customer</h5>
                        </div>
                        <div className="counter-items wow fadeInUp" data-wow-delay=".8s" style={{ visibility: 'visible', animationDelay: '0.8s', animationName: 'fadeInUp', textAlign: "center" }}>
                            <div className="fun-fact-value" data-module="countup">
                                <span className="start-number" data-countup-number={15}>15</span>+
                            </div>

                            <h5>Wining Awards</h5>
                        </div>
                    </div>
                </div>
            </section>

            <section className="service-section-4 section-space" style={{ marginTop: "-40px" }}>
                <div className="container">
                    <div className="service-wrapper-4">
                        <div className="row g-4">
                            <div className="col-lg-6">
                                <div className="team-content-4 sticky-style">
                                    <div className="section-content-block ">
                                        <span className="section-tag wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>Welcome to Rahul Logistics Katni</span>
                                        <h2 className="section-title is-text-dark">
                                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                                Safety Policy
                                            </div>
                                        </h2>
                                    </div>
                                    <p className="section-text wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp', textAlign: "justify" }}>
                                        “Safety is a legitimate personal expectation and a constant individual responsibility. Every member of staff should be able to go home at the end of the working day without having suffered or caused harm in any way.”
                                    </p>
                                    <p className="section-text wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp', textAlign: "justify" }}>
                                        We as an organization are committed to safe operations at different levels of our organization and are sincerely following our safety policy which is Safety To 3M’s ( Men, Material and Machine) and we strongly believe that by doing the same we will help in protecting the Environment as well.
                                    </p>
                                    <p className="section-text wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp', textAlign: "justify" }}>
                                        We believe in not just doing business but doing the same safely in all aspects of our operations like the 3M and to ensure that all our operations are safe for business.
                                    </p>
                                    <p className="section-text wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp', textAlign: "justify" }}>
                                        Being in the road service industry where our operations are exposed to 3M are not limited to our organization alone. It is here, where we feel that we have a much more important role in the safety cause, where by doing operations safely we will ensure safety not just to our operations but also to all concerned.
                                    </p>
                                    <p className="section-text wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp', textAlign: "justify" }}>
                                        We believe that all customers associated with us have the right that their consignments reach safely or the personnel manning our vehicles are trained for safe operations and the vehicles are safe enough for the journey making the entire process of our business safe.
                                    </p>
                                    <p className="section-text wow fadeInUp" data-wow-delay=".3s" style={{ visibility: 'visible', animationDelay: '0.3s', animationName: 'fadeInUp', textAlign: "justify" }}>
                                        Everyone in this organization is committed to the safe operations and Safety To 3M’s.
                                    </p>

                                    <Link to="/contact-us" className="btn btn-secondary-alt mt-5 wow fadeInUp" data-wow-delay=".5s" style={{ visibility: 'visible', animationDelay: '0.5s', animationName: 'fadeInUp' }}>
                                        Contact Us
                                        <div className="btn-icon">
                                            <span>
                                                <i className="fa-regular fa-arrow-right" />
                                            </span>
                                            <span>
                                                <i className="fa-regular fa-arrow-right" />
                                            </span>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="service-image-4">
                                    <div className="service-image">
                                        <img src="assets/images/home-3/service/home-4-02.jpg" alt="img" />
                                        <div className="service-content">
                                            <div className="service-icon-items">
                                                <div className="icon">
                                                    <img src="assets/images/home-3/service/icon-5.svg" alt="img" />
                                                </div>
                                                <h3><a to="service-details.html">Road Transportation</a></h3>
                                            </div>
                                            <p>We are committed to providing the best service to ensure your success..</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="service-image-4 mt-0">
                                    <div className="service-image">
                                        <img src="assets/img/Rail Transportation.jpg" alt="img" />
                                        <div className="service-content">
                                            <div className="service-icon-items">
                                                <div className="icon">
                                                    <img src="assets/images/home-3/service/icon-5.svg" alt="img" />
                                                </div>
                                                <h3><a to="service-details.html">Rail Transportation</a></h3>
                                            </div>
                                            <p>We are committed to providing the best service to ensure your success..</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="service-image-4">
                                    <div className="service-image">
                                        <img src="assets/images/home-3/service/home-4-03.jpg" alt="img" />
                                        <div className="service-content">
                                            <div className="service-icon-items">
                                                <div className="icon">
                                                    <img src="assets/images/home-3/service/icon-5.svg" alt="img" />
                                                </div>
                                                <h3><a to="service-details.html">Air Transportation</a></h3>
                                            </div>
                                            <p>We are committed to providing the best service to ensure your success..</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>




        </>
    )
}

export default HomeAbout